import { render, staticRenderFns } from "./defaultTable.vue?vue&type=template&id=54468268&scoped=true&"
import script from "./defaultTable.vue?vue&type=script&lang=ts&"
export * from "./defaultTable.vue?vue&type=script&lang=ts&"
import style0 from "./defaultTable.vue?vue&type=style&index=0&id=54468268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54468268",
  null
  
)

export default component.exports